import React, { useEffect, useRef, useState } from "react";
import { Calendar } from "react-date-range";
import { getDateString } from "../../../../utils/dateutils";
import "../scheduledetails/style/calenderdate.css";
import SmartIcon from "../../../../components/generic/genericIcon/SmartIcon";

const CalenderAndDate = ({ date, onDateChange, label, readOnly, right, required }) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const datePickerRef = useRef(null);
  const buttonRef = useRef(null);
  const [displayDate, setDisplayDate] = useState(date ? getDateString(date) : "");
  const rootStyles = getComputedStyle(document.documentElement);
  const mainThemeColor = rootStyles
    .getPropertyValue("--main-theme-color")
    .trim();

  const handleClickOutside = (event) => {
    if (
      datePickerRef.current &&
      !datePickerRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setShowDatePicker(false);
    }
  };

  const handleToggleDatePicker = () => {
    setShowDatePicker(!showDatePicker);
  };

  const handleSelect = (date) => {
    const formattedDate = date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
    setDisplayDate(formattedDate);
    onDateChange(formattedDate);
  };

  useEffect(() => {
    setDisplayDate(date ? getDateString(date) : "");
  }, [date]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="position-relative">
      <div className="calender-date">
        <div className="display-date">
          <span className={`${required ? "required-mark-label" : ""}`}>{label}</span>
          <b>{" "}{displayDate || "--"}</b>
        </div>
        <div
          ref={buttonRef}
          onClick={handleToggleDatePicker}
          className="cursor-pointer"
        >
          <SmartIcon iconKey={"colorCalendar"} />
        </div>
      </div>
      {showDatePicker && (
        <div
          className="date-picker-wrapper"
          ref={datePickerRef}
          style={{
            position: "absolute",
            zIndex: "9999",
            display: "flex",
            justifyContent: "end",
            top: "40px",
            ...(right !== undefined && right !== null && { right } )
          }}
        >
          <Calendar
            date={displayDate ? new Date(displayDate) : new Date()}
            onChange={handleSelect}
            maxDate={new Date()}
            color={mainThemeColor}
            rangeColors={[mainThemeColor]}
            disabledDay={() => readOnly}
          />
        </div>
      )}
    </div>
  );
};

export default CalenderAndDate;
